import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PRODUCT_TYPES } from '../../../../../core/helpers/constants';
import { IProductFinalized } from '../../../../../core/models/products.models';

@Component({
  selector: 'app-ad-spend',
  templateUrl: './ad-spend.component.html',
  styleUrls: ['./ad-spend.component.scss']
})
export class AdSpendComponent {
  PRODUCT_TYPES = PRODUCT_TYPES;

  @Input() finalizedProducts: Array<IProductFinalized> = [];
  @Input() stepsData!: FormArray; 
  @Input() productAdSpendOptions!: Map<string, number[]>; 
  @Input() addingFacebook: boolean = false; 
  @Input() addingGoogle: boolean = false; 
  @Input() hasGoogle: boolean = false;
  @Input() hasFacebook: boolean = false;
  @Input() cartForm!: FormGroup;

  @Output() previous = new EventEmitter<void>(); 
  @Output() continue = new EventEmitter<void>(); 
  @Output() switchChange = new EventEmitter<{ evt: any, index: number }>();
  @Output() finalizeProducts = new EventEmitter<void>(); 

  managementFeeProducts: any[] = [];
  nonManagementFeeProducts: any[] = [];

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.filterProducts();
  }

  filterProducts() {
    if (!this.stepsData) {
      this.managementFeeProducts = [];
      this.nonManagementFeeProducts = [];
      return;
    }
    const products = this.stepsData.controls.map((ctrl, i) => ({ ctrl, i }));
    this.managementFeeProducts = products.filter(({ ctrl }) =>
      ctrl.value.display.includes('Fee') && ctrl.value.display.includes('Management')
    );
    this.nonManagementFeeProducts = products.filter(({ ctrl }) =>
      !(ctrl.value.display.includes('Fee') && ctrl.value.display.includes('Management'))
    );
  }

  onPrevious(): void {
    this.previous.emit();
  }

  onContinue(): void {
    // Perform any validation or finalization logic here if needed
    this.continue.emit();
  }

  onSwitchChange(evt: any, index: number) {
    this.stepsData.at(index).get('includeProduct')?.setValue(evt);

    this.switchChange.emit({ evt, index });
  }

  doFinalizeProducts() {
    this.finalizeProducts.emit();
  }

  translateDuration(duration: any): string {
    const rawDuration = String(duration ?? '').trim();
    const durationKey = rawDuration.toUpperCase();
    const translatedDuration = ['DAY', 'WEEK', 'MONTH', 'YEAR'].includes(durationKey)
      ? this.translate.instant(durationKey)
      : '';

    return translatedDuration || rawDuration;
  }

  showRecurring() {
    return this.finalizedProducts.findIndex(x => x.type === PRODUCT_TYPES.SimpleSubscription.code || x.type === PRODUCT_TYPES.VariableSubscription.code) >= 0;
  }

  trackByProduct(index: number, item: any) {
    // Use a unique identifier, such as the product id
    return item.ctrl?.get('id')?.value ?? index;
  }

  trackByAdSpendOption(index: number, option: number) {
    return option;
  }
}
